import { createAsyncThunk } from '@reduxjs/toolkit';
import { getRequest, putRequest } from '../../../../axios/requests';
import API from '../../../../constant.api';

export const getIncentives = createAsyncThunk(
  'incentives/list',
  async (payload: Record<string, string | number | undefined>, { rejectWithValue }) => {
    try {
      const { data } = await getRequest(API.INCENTIVES, payload);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const payIncentive = createAsyncThunk(
  'incentives/pay',
  async (payload: { id: string; onlineAmount: number; offlineAmount: number }, { rejectWithValue }) => {
    try {
      const { data } = await putRequest(`${API.INCENTIVES}/${payload.id}/pay`, {
        onlineAmount: payload.onlineAmount,
        offlineAmount: payload.offlineAmount,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const rejectIncentive = createAsyncThunk(
  'incentives/reject',
  async (payload: { id: string }, { rejectWithValue }) => {
    try {
      const { data } = await putRequest(`${API.INCENTIVES}/${payload.id}/reject`, {});
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
